import React, { useRef } from "react"
import CenterButton from "components/Organisms/map/CenterButton"
import Map from "components/Organisms/map/Map"
import { useTripRecommendations } from "graphql/trip/trip.hooks"
import { ultraLightWithLabels } from "utils/mapStyles"
import RecommendationService from "./RecommendationService"
import TrackingMapLegends from "./TrackingMapLegends"
import TripDirectionsService from "./TripDirectionsService"
import { getPosition } from "utils/custom.utils"
import useAuth, { useDeptFrontend } from "hooks/useAuth"
import AllDCLocations from "components/Templates/AllDCLocations"
function TripTrackingMap({ bookings, tripDetails, source, destination }) {
  const auth = useAuth()
  const mapRef = useRef<google.maps.Map>()
  const isEcommerce = useDeptFrontend()
  const { data: recommendations } = useTripRecommendations()

  return (
    <Map
      styles={ultraLightWithLabels}
      mapContainerStyle={{
        height: 470,
      }}
      id="vt-trip-tracking-google-map"
      onLoad={googleMap => {
        mapRef.current = googleMap
      }}
      center={
        tripDetails?.latitude && tripDetails?.longitude
          ? {
              lat: parseFloat(tripDetails?.latitude),
              lng: parseFloat(tripDetails?.longitude),
            }
          : { lat: 20.152682, lng: 73.882598 }
      }
      zoom={12}
    >
      <CenterButton
        onClick={() => {
          if (mapRef?.current) {
            const trackingMapBounds = new window.google.maps.LatLngBounds()
            let bounds = []
            // Extend the bounds for all the BOOKINGS
            for (const booking of bookings ?? []) {
              const address =
                booking?.order?.shippingAddress ??
                booking?.schedule?.plot?.address

              if (address?.latitude && address?.longitude) {
                bounds.push({
                  lat: address?.latitude,
                  lng: address?.longitude,
                })
              }
            }
            // Also Extend the bounds for all the Recommendations
            for (const recommendation of recommendations ?? []) {
              const address = recommendation?.plot?.address
              if (address?.latitude && address?.longitude) {
                bounds.push({
                  lat: address?.latitude,
                  lng: address?.longitude,
                })
              }
            }
            // Extend The Bounds for origin and location
            bounds.push(getPosition(source?.location))
            bounds.push(getPosition(destination?.location))

            // Include the vehicle in the array
            if (tripDetails?.latitude && tripDetails?.longitude) {
              bounds.push({
                lat: parseFloat(tripDetails?.latitude),
                lng: parseFloat(tripDetails?.longitude),
              })
            }

            // Apply the entire bounds array for trackinMap
            bounds.forEach(b => {
              if (b) {
                trackingMapBounds.extend(b)
              }
            })

            // Adjust the map according to
            mapRef.current.fitBounds(trackingMapBounds)
          }
        }}
      />
      <TripDirectionsService
        source={source}
        destination={destination}
        bookings={bookings}
      />
      {isEcommerce ? null : (
        <RecommendationService recommendations={recommendations} />
      )}
      {isEcommerce ? (
        <AllDCLocations variables={{ pocId: auth.user.id }} />
      ) : null}
      <TrackingMapLegends />
    </Map>
  )
}

export default TripTrackingMap
